var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPfeilUntenGrau = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "108.9px",
    height: "60.3px",
    viewBox: "0 0 108.9 60.3",
    enableBackground: "new 0 0 108.9 60.3",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#8F8F8F",
    points: "54.7,60.3 0,5.7 5.7,0 54.7,49 103.2,0.5 108.9,6.1  "
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPfeilUntenGrau, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pfeil_unten_grau.48c0d2a2.svg";
export { ForwardRef as ReactComponent };